import React from 'react';
import { useOutletContext } from 'react-router-dom';
import ClaimGift from './ClaimGift';
import ClaimHTLCGift from './ClaimHTLCGift';

const GiftClaimRouter = () => {
  const { gift } = useOutletContext();

  if (!gift) {
    return <p>Gift not found or no longer available.</p>;
  }

  // Determine if this is an HTLC gift
  const isHTLCGift = gift?.htlcAccount || gift?.status?.includes('HTLC');

  // Route to appropriate component based on gift type
  if (isHTLCGift) {
    return <ClaimHTLCGift />;
  }

  // Default to regular gift claim
  return <ClaimGift />;
};

export default GiftClaimRouter;
